import script from "./gradeList.vue?vue&type=script&setup=true&lang=js"
export * from "./gradeList.vue?vue&type=script&setup=true&lang=js"

import "./gradeList.vue?vue&type=style&index=0&id=5c2bfb8f&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c2bfb8f"]])

export default __exports__